import { render } from "./Crafting.vue?vue&type=template&id=747e37e1&scoped=true"
import script from "./Crafting.vue?vue&type=script&lang=js"
export * from "./Crafting.vue?vue&type=script&lang=js"

import "./Crafting.vue?vue&type=style&index=0&id=747e37e1&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747e37e1"]])

export default __exports__